export default "__VITE_ASSET__Bqe$YWGL__"